import SIMPLE_PAYWALL_1M_29_99_1W_4_99 from './paywall/SIMPLE_PAYWALL_1M_29_99_1W_4_99'
import SIMPLE_PAYWALL_1M_29_99_1M_17_99 from './paywall/SIMPLE_PAYWALL_1M_29_99_1M_17_99'
import SIMPLE_PAYWALL_3M_59_99_3M_29_99 from './paywall/SIMPLE_PAYWALL_3M_59_99_3M_29_99'
import SIMPLE_PAYWALL_1M_29_99_1W_4 from './paywall/SIMPLE_PAYWALL_1M_29_99_1W_4'
import SIMPLE_PREMIUM_4W_44_1W_5_19 from './paywall/SIMPLE_PREMIUM_4W_44_1W_5_19'
import SIMPLE_PREMIUM_4W_44_4W_9_99 from './paywall/SIMPLE_PREMIUM_4W_44_4W_9_99'
import SIMPLE_PREMIUM_12W_79_12W_19_99 from './paywall/SIMPLE_PREMIUM_12W_79_12W_19_99'

import SIMPLE_UPGRADE_3M_59 from './upgrade/SIMPLE_UPGRADE_3M_59'
import SIMPLE_UPGRADE_3M_47_2 from './upgrade/SIMPLE_UPGRADE_3M_47_2'
import SIMPLE_UPGRADE_6M_79 from './upgrade/SIMPLE_UPGRADE_6M_79'
import SIMPLE_UPGRADE_6M_63_2 from './upgrade/SIMPLE_UPGRADE_6M_63_2'
import SIMPLE_UPGRADE_9M_99 from './upgrade/SIMPLE_UPGRADE_9M_99'
import SIMPLE_UPGRADE_9M_79_2 from './upgrade/SIMPLE_UPGRADE_9M_79_2'

import SIMPLE_PAYWALL_1M_29_99_1M_29_99 from './paywall/SIMPLE_PAYWALL_1M_29_99_1M_29_99'
import SIMPLE_PAYWALL_1M_29_99_1W_9_99 from './paywall/SIMPLE_PAYWALL_1M_29_99_1W_9_99'
import SIMPLE_PAYWALL_3M_59_99_3M_59_99 from './paywall/SIMPLE_PAYWALL_3M_59_99_3M_59_99'

import SIMPLE_UPGRADE_3M_44_97 from './upgrade/SIMPLE_UPGRADE_3M_44_97'

import SIMPLE_CANCEL_OFFER_1M_2999_3M_1 from '@/data/products/cancel-offer/SIMPLE_CANCEL_OFFER_1M_2999_3M_1'
import SIMPLE_CANCEL_OFFER_1M_5 from '@/data/products/cancel-offer/SIMPLE_CANCEL_OFFER_1M_5'

// web_self_assessment_with_intro_prices
import SIMPLE_ASSESSMENT_14_99 from './assessment/SIMPLE_ASSESSMENT_14_99'

// IN APP PAYWALL
import SIMPLE_IN_APP_1M_29_99_1M_13_99 from './in-app/SIMPLE_IN_APP_1M_29_99_1M_13_99'
import SIMPLE_IN_APP_3M_59_99_3M_20_99 from './in-app/SIMPLE_IN_APP_3M_59_99_3M_20_99'

import SIMPLE_PAYWALL_4W_29_99_1W_4_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_1W_4_99'
import SIMPLE_PAYWALL_4W_29_99_1W_9_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_1W_9_99'
import SIMPLE_PAYWALL_4W_29_99_4W_17_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_4W_17_99'
import SIMPLE_PAYWALL_4W_29_99_4W_29_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_4W_29_99'
import SIMPLE_PAYWALL_12W_59_99_12W_29_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_12W_59_99_12W_29_99'
import SIMPLE_PAYWALL_12W_59_99_12W_59_99 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_12W_59_99_12W_59_99'
import SIMPLE_PAYWALL_4W_29_99_12W_30_00 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_12W_30_00'
import SIMPLE_PAYWALL_4W_29_99_24W_12_00 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_24W_12_00'
import SIMPLE_PAYWALL_4W_29_99_4W_44_00 from './paywall/bill_in_weeks/SIMPLE_PAYWALL_4W_29_99_4W_44_00'
import SIMPLE_PREMIUM_12W_66_65_12W_25_99 from './experiments/paywall/SIMPLE_PREMIUM_12W_66_65_12W_25_99'
import SIMPLE_PREMIUM_12W_66_65_12W_66_65 from './experiments/paywall/SIMPLE_PREMIUM_12W_66_65_12W_66_65'

import SIMPLE_PREMIUM_4W_38_95_1W_6_93 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_1W_6_93'
import SIMPLE_PREMIUM_4W_38_95_1W_17_77 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_1W_17_77'
import SIMPLE_PREMIUM_4W_38_95_4W_15_19 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_4W_15_19'
import SIMPLE_PREMIUM_4W_38_95_4W_38_95 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_4W_38_95'
import SIMPLE_PREMIUM_4W_38_95_1W_5_54 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_1W_5_54'
import SIMPLE_PREMIUM_4W_38_95_4W_12_15 from './experiments/paywall/SIMPLE_PREMIUM_4W_38_95_4W_12_15'
import SIMPLE_PREMIUM_12W_66_65_12W_20_79 from './experiments/paywall/SIMPLE_PREMIUM_12W_66_65_12W_20_79'

import SIMPLE_PAYWALL_1M_39_1M_9_99 from './experiments/paywall/SIMPLE_PAYWALL_1M_39_1M_9_99'
import SIMPLE_PAYWALL_1M_39_1W_5_99 from './experiments/paywall/SIMPLE_PAYWALL_1M_39_1W_5_99'
import SIMPLE_PAYWALL_3M_69_3M_19_99 from './experiments/paywall/SIMPLE_PAYWALL_3M_69_3M_19_99'

// EU pricing products with equal trial and subscription prices
import SIMPLE_PAYWALL_1M_39_1M_39 from './experiments/paywall/SIMPLE_PAYWALL_1M_39_1M_39'
import SIMPLE_PAYWALL_3M_69_3M_69 from './experiments/paywall/SIMPLE_PAYWALL_3M_69_3M_69'
import SIMPLE_PAYWALL_1M_39_1W_12 from './experiments/paywall/SIMPLE_PAYWALL_1M_39_1W_12'

// web_pricing_per_funnel experiment products
import SIMPLE_PREMIUM_1M_44_1W_5_19 from './experiments/paywall/SIMPLE_PREMIUM_1M_44_1W_5_19'
import SIMPLE_PREMIUM_1M_44_1M_9_99 from './experiments/paywall/SIMPLE_PREMIUM_1M_44_1M_9_99'
import SIMPLE_PREMIUM_3M_79_3M_19_99 from './experiments/paywall/SIMPLE_PREMIUM_3M_79_3M_19_99'
import SIMPLE_PREMIUM_1M_44_1W_22 from './experiments/paywall/SIMPLE_PREMIUM_1M_44_1W_22'
import SIMPLE_PREMIUM_1M_44_1M_44 from './experiments/paywall/SIMPLE_PREMIUM_1M_44_1M_44'
import SIMPLE_PREMIUM_3M_79_3M_79 from './experiments/paywall/SIMPLE_PREMIUM_3M_79_3M_79'

// web_pro_version_activity_funnels experiment products
import SIMPLE_PREMIUM_1M_49_1M_14_99 from './experiments/paywall/SIMPLE_PREMIUM_1M_49_1M_14_99'
import SIMPLE_PREMIUM_1M_49_1M_49 from './experiments/paywall/SIMPLE_PREMIUM_1M_49_1M_49'

// web_pricing_on_fasting_funnels_with_sp
import SIMPLE_PREMIUM_4W_44_1W_4_15 from './experiments/paywall/SIMPLE_PREMIUM_4W_44_1W_4_15'
import SIMPLE_PREMIUM_4W_44_4W_7_99 from './experiments/paywall/SIMPLE_PREMIUM_4W_44_4W_7_99'
import SIMPLE_PREMIUM_12W_79_12W_15_99 from './experiments/paywall/SIMPLE_PREMIUM_12W_79_12W_15_99'

// web_pricing_for_desktop
import SIMPLE_PREMIUM_4W_49_1W_6_19 from './experiments/paywall/SIMPLE_PREMIUM_4W_49_1W_6_19'
import SIMPLE_PREMIUM_4W_49_4W_11_99 from './experiments/paywall/SIMPLE_PREMIUM_4W_49_4W_11_99'
import SIMPLE_PREMIUM_12W_99_12W_23_99 from './experiments/paywall/SIMPLE_PREMIUM_12W_99_12W_23_99'
import SIMPLE_PREMIUM_4W_49_1W_22 from './experiments/paywall/SIMPLE_PREMIUM_4W_49_1W_22'
import SIMPLE_PREMIUM_4W_49_4W_49 from './experiments/paywall/SIMPLE_PREMIUM_4W_49_4W_49'
import SIMPLE_PREMIUM_12W_99_12W_99 from './experiments/paywall/SIMPLE_PREMIUM_12W_99_12W_99'

// web_en_countries_price_optimization experiment products
// old_shorts
import SIMPLE_PREMIUM_1M_38_95_1W_6_93_EN_CLUSTER from './experiments/paywall/web_en_countries_price_optimization/old_shorts/SIMPLE_PREMIUM_1M_38_95_1W_6_93_EN_CLUSTER'
import SIMPLE_PREMIUM_1M_38_95_1M_14_99_EN_CLUSTER from './experiments/paywall/web_en_countries_price_optimization/old_shorts/SIMPLE_PREMIUM_1M_38_95_1M_14_99_EN_CLUSTER'
import SIMPLE_PREMIUM_3M_66_65_3M_24_99_EN_CLUSTER from './experiments/paywall/web_en_countries_price_optimization/old_shorts/SIMPLE_PREMIUM_3M_66_65_3M_24_99_EN_CLUSTER'

// new_shorts
import SIMPLE_PREMIUM_1M_38_95_1M_12_99_EN_CLUSTER from './experiments/paywall/web_en_countries_price_optimization/new_shorts/SIMPLE_PREMIUM_1M_38_95_1M_12_99_EN_CLUSTER'
import SIMPLE_PREMIUM_3M_66_65_3M_21_99_EN_CLUSTER from './experiments/paywall/web_en_countries_price_optimization/new_shorts/SIMPLE_PREMIUM_3M_66_65_3M_21_99_EN_CLUSTER'

// GLP
import SIMPLE_PREMIUM_4W_349_4W_199 from './paywall/SIMPLE_PREMIUM_4W_349_4W_199'
import SIMPLE_PREMIUM_12W_657_12W_387 from './paywall/SIMPLE_PREMIUM_12W_657_12W_387'
import SIMPLE_PREMIUM_24W_1194_24W_594 from './paywall/SIMPLE_PREMIUM_24W_1194_24W_594'

export default {
	SIMPLE_PAYWALL_1M_29_99_1W_4_99,
	SIMPLE_PAYWALL_1M_29_99_1M_17_99,
	SIMPLE_PAYWALL_3M_59_99_3M_29_99,

	SIMPLE_UPGRADE_3M_59,
	SIMPLE_UPGRADE_3M_47_2,
	SIMPLE_UPGRADE_6M_79,
	SIMPLE_UPGRADE_6M_63_2,
	SIMPLE_UPGRADE_9M_99,
	SIMPLE_UPGRADE_9M_79_2,

	SIMPLE_PAYWALL_1M_29_99_1M_29_99,
	SIMPLE_PAYWALL_1M_29_99_1W_9_99,
	SIMPLE_PAYWALL_3M_59_99_3M_59_99,

	SIMPLE_UPGRADE_3M_44_97,

	// Cancel offers
	SIMPLE_CANCEL_OFFER_1M_2999_3M_1,
	SIMPLE_CANCEL_OFFER_1M_5,

	// Assessment
	SIMPLE_ASSESSMENT_14_99,
	SIMPLE_PAYWALL_1M_29_99_1W_4,

	// IN APP PAYWALL
	SIMPLE_IN_APP_1M_29_99_1M_13_99,
	SIMPLE_IN_APP_3M_59_99_3M_20_99,

	SIMPLE_PAYWALL_4W_29_99_1W_4_99,
	SIMPLE_PAYWALL_4W_29_99_4W_17_99,
	SIMPLE_PAYWALL_12W_59_99_12W_29_99,
	SIMPLE_PAYWALL_4W_29_99_12W_30_00,
	SIMPLE_PAYWALL_4W_29_99_24W_12_00,
	SIMPLE_PAYWALL_4W_29_99_4W_44_00,
	SIMPLE_PREMIUM_12W_66_65_12W_25_99,
	SIMPLE_PAYWALL_4W_29_99_1W_9_99,
	SIMPLE_PAYWALL_4W_29_99_4W_29_99,
	SIMPLE_PAYWALL_12W_59_99_12W_59_99,
	SIMPLE_PREMIUM_12W_66_65_12W_66_65,

	SIMPLE_PREMIUM_4W_38_95_1W_6_93,
	SIMPLE_PREMIUM_4W_38_95_1W_17_77,
	SIMPLE_PREMIUM_4W_38_95_4W_15_19,
	SIMPLE_PREMIUM_4W_38_95_4W_38_95,
	SIMPLE_PREMIUM_4W_38_95_1W_5_54,
	SIMPLE_PREMIUM_4W_38_95_4W_12_15,
	SIMPLE_PREMIUM_12W_66_65_12W_20_79,

	// web_europe_pricing_tier_1
	SIMPLE_PAYWALL_1M_39_1W_5_99,
	SIMPLE_PAYWALL_1M_39_1M_9_99,
	SIMPLE_PAYWALL_3M_69_3M_19_99,

	// EU pricing products with equal trial and subscription prices
	SIMPLE_PAYWALL_1M_39_1M_39,
	SIMPLE_PAYWALL_3M_69_3M_69,
	SIMPLE_PAYWALL_1M_39_1W_12,

	// web_pricing_per_funnel experiment products
	SIMPLE_PREMIUM_1M_44_1W_5_19,
	SIMPLE_PREMIUM_1M_44_1M_9_99,
	SIMPLE_PREMIUM_3M_79_3M_19_99,
	SIMPLE_PREMIUM_1M_44_1W_22,
	SIMPLE_PREMIUM_1M_44_1M_44,
	SIMPLE_PREMIUM_3M_79_3M_79,

	// web_pro_version_activity_funnels experiment products
	SIMPLE_PREMIUM_1M_49_1M_14_99,
	SIMPLE_PREMIUM_1M_49_1M_49,

	// web_en_countries_price_optimization experiment products
	// old_shorts
	SIMPLE_PREMIUM_1M_38_95_1W_6_93_EN_CLUSTER,
	SIMPLE_PREMIUM_1M_38_95_1M_14_99_EN_CLUSTER,
	SIMPLE_PREMIUM_3M_66_65_3M_24_99_EN_CLUSTER,

	// new_shorts
	SIMPLE_PREMIUM_1M_38_95_1M_12_99_EN_CLUSTER,
	SIMPLE_PREMIUM_3M_66_65_3M_21_99_EN_CLUSTER,

	// web_pricing_on_fasting_funnels_with_sp
	SIMPLE_PREMIUM_4W_44_1W_5_19,
	SIMPLE_PREMIUM_4W_44_4W_9_99,
	SIMPLE_PREMIUM_12W_79_12W_19_99,
	SIMPLE_PREMIUM_4W_44_1W_4_15,
	SIMPLE_PREMIUM_4W_44_4W_7_99,
	SIMPLE_PREMIUM_12W_79_12W_15_99,

	// web_pricing_for_desktop
	SIMPLE_PREMIUM_4W_49_1W_6_19,
	SIMPLE_PREMIUM_4W_49_4W_11_99,
	SIMPLE_PREMIUM_12W_99_12W_23_99,
	SIMPLE_PREMIUM_4W_49_1W_22,
	SIMPLE_PREMIUM_4W_49_4W_49,
	SIMPLE_PREMIUM_12W_99_12W_99,

	// GLP
	SIMPLE_PREMIUM_4W_349_4W_199,
	SIMPLE_PREMIUM_12W_657_12W_387,
	SIMPLE_PREMIUM_24W_1194_24W_594,
}
